// Amendment audit trail helpers. Amendments live in order.adjustments; older
// ones predate the type tag and are recognised by amendedAt.

export const isAmendAdjustment = (adjustment) => {
  if (!adjustment || typeof adjustment !== 'object') return false;
  if (adjustment.type === 'amend') return true;
  return !adjustment.type && Boolean(adjustment.amendedAt);
};

const toItemList = (items) => {
  if (!items) return [];
  return Array.isArray(items) ? items : Object.values(items);
};

const sumQuantities = (items) => toItemList(items).reduce((acc, item) => {
  if (!item?.name) return acc;
  acc.set(item.name, (acc.get(item.name) || 0) + (Number(item.quantity) || 0));
  return acc;
}, new Map());

// Per-item quantity changes, in the order items first appear.
export const diffAmendedItems = (originalItems, newItems) => {
  const before = sumQuantities(originalItems);
  const after = sumQuantities(newItems);
  const names = [...new Set([...before.keys(), ...after.keys()])];
  return names
    .map((name) => {
      const from = before.get(name) || 0;
      const to = after.get(name) || 0;
      return { name, from, to, change: to - from };
    })
    .filter((row) => row.change !== 0);
};

const DETAIL_FIELDS = [
  ['originalCustomerName', 'newCustomerName', 'Customer name'],
  ['originalCustomerPhone', 'newCustomerPhone', 'Phone'],
  ['originalCustomerAddress', 'newCustomerAddress', 'Address'],
];

// Newest first, ready to render.
export const getAmendmentHistory = (order) => {
  const adjustments = Array.isArray(order?.adjustments) ? order.adjustments : [];
  return adjustments
    .filter(isAmendAdjustment)
    .map((adjustment) => {
      // The amend flow records '' against a missing value as a change; skip those.
      const detailChanges = DETAIL_FIELDS
        .map(([fromKey, toKey, label]) => ({ label, from: adjustment[fromKey] || '', to: adjustment[toKey] || '' }))
        .filter((change) => change.from !== change.to);
      const fromMethod = adjustment.originalPaymentMethod || null;
      const toMethod = adjustment.newPaymentMethod || null;
      return {
        at: adjustment.amendedAt,
        by: adjustment.amendedBy || 'Unknown',
        reason: adjustment.reason || '',
        originalTotal: Number(adjustment.originalTotal) || 0,
        newTotal: Number(adjustment.newTotal) || 0,
        diffAmount: Number(adjustment.diffAmount) || 0,
        itemChanges: diffAmendedItems(adjustment.originalItems, adjustment.newItems),
        paymentChange: fromMethod !== toMethod && toMethod ? { from: fromMethod, to: toMethod } : null,
        detailChanges,
      };
    })
    .sort((a, b) => new Date(b.at) - new Date(a.at));
};
